import { apiCall } from './apiClient';

// --- Authentication Endpoints ---

export const registerUser = (email, password, role = 'USER') =>
  apiCall('/authentication/auths/register', {
    method: 'POST',
    body: JSON.stringify({ email, password, role })
  });

export const loginUser = (email, password) =>
  apiCall('/authentication/auths/login', {
    method: 'POST',
    body: JSON.stringify({ email, password })
  });

export const forgotPassword = (email) =>
  apiCall('/authentication/auths/forgot-password', {
    method: 'POST',
    body: JSON.stringify({ email })
  });

export const resetPassword = (email, otp, newPassword) =>
  apiCall('/authentication/auths/reset-password', {
    method: 'POST',
    body: JSON.stringify({ email, otp, new_password: newPassword })
  });


  
  